import {convertorRplyCardType} from './utilities';
interface MarketPostProps {
  post?: UserMessagesMarketPost;
  type: string;
}
const MarketPost = ({post, type}: MarketPostProps) => {
  return <>{post && convertorRplyCardType[type](post)}</>;
};

export default MarketPost;
